export default __webpack_public_path__ + "static/media/landing.e1bcbf5a.png";